<template>
    <main>

        <!-- Hero -->
        <div class="hero tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-w-full">

            <div class="hero-info">

                <div class="tw-container hero-text">
                    <div class="logo tw-flex tw-justify-center lg:tw-justify-start">
                        <img src="@/assets/img/logo.svg">
                    </div>

                    <h1>Somos líderes em estudos de mercado sobre consumo</h1>

                    <h3>Convidamo-lo a <span>participar no nosso projeto</span> sobre hábitos de consumo.</h3>

                </div>

                <div class="hero-image tw-hidden lg:tw-block">
                    <img src="@/assets/img/hero-image.jpg">
                </div>

            </div>

            <div class="hero-form">

                <div class="tw-container" v-if="!$store.state.formSuccess && !$store.state.formError">
                    <h2 id="top">Participe aqui<br>e ganhe prémios!</h2>
                    <p>É grátis e demora apenas 2 minutos</p>

                    <div class="arrow-icon" v-if="!$store.state.formSuccess">
                        <img src="@/assets/img/icons/arrow.svg">
                    </div>
                </div>

                <div>
                    <Form v-if="!$store.state.formSuccess && !$store.state.formError" />
                    <FormSuccess v-if="$store.state.formSuccess && !$store.state.formError" />
                    <FormError v-if="!$store.state.formSuccess && $store.state.formError" />
                </div>
            </div>

        </div>

        <!-- Grid -->
        <div class="brindes tw-container">

            <!-- Desktop -->
            <div class="desktop tw-hidden lg:tw-block">
                <div class="first-grid tw-grid tw-grid-cols-2">
                    <div class="squares tw-grid tw-grid-cols-3">
                        <div v-for="(brinde, index) in brindes.slice(0, 6)" :key="index">
                            <img :src="`/brindes/${brinde}.png`">
                        </div>
                    </div>
                    <div class="info">
                        <h1>Comece hoje mesmo!</h1>
                        <p>Premiamos a sua colaboração através da atribuição de pontos que poderão ser trocados por <span>brindes do nosso catálogo</span>.</p>
                    </div>
                </div>
                <div class="second-grid tw-grid tw-grid-cols-5">
                    <div v-for="(brinde, index) in brindesSecond" :key="index">
                        <img :src="`/brindes/${brinde}.png`">
                    </div>
                </div>
            </div>

            <!-- Mobile -->
            <div class="mobile tw-grid tw-grid-cols-1 lg:tw-hidden">
                <div class="tw-grid tw-grid-cols-3">
                    <div v-for="(brinde, index) in brindes" :key="index">
                        <img :src="`/brindes/${brinde}.png`">
                    </div>
                </div>
                <div class="info">
                    <h1>Comece hoje mesmo!</h1>
                    <p>Premiamos a sua colaboração através da atribuição de pontos que poderão ser trocados por <span>brindes do nosso catálogo</span>.</p>
                    <button class="btn-cta tw-mb-20" v-scroll-to="'.hero'">PARTICIPAR</button>
                </div>
            </div>
        </div>

    </main>
</template>
<script>
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';
import FormError from '@/components/FormError.vue';

export default {
    name: 'Home',
    components: {
        Form,
        FormSuccess,
        FormError,
    },
    data() {

        return {
            brindes: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21'],
            brindesSecond: ['7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21'],
        };
    },
};
</script>
